import { useCallback, useState } from 'react'
import { ActionCardData, getActiveTagNames } from '@playbooks/action-cards-utils/src'
import { ActionCardsElement } from '@playbooks/action-cards/types'

import { checkCompletionKeywords } from '../services/completionKeywordsService'
import useMountEffect from './useMountEffect'

// This hook checks if the active tags (actionCardData.conditionalItems)
// match the completion keywords defined in the settings.
function useCompletionKeywordsMatch({
  completionKeywords,
  actionCardsElementRef,
}: {
  completionKeywords: Set<string | null> | null
  actionCardsElementRef: React.RefObject<ActionCardsElement | null>
}) {
  const [isCompletionKeywordsMatched, setIsCompletionKeywordsMatched] = useState(false)

  const adjustCompletionKeywordsState = useCallback(() => {
    if (!actionCardsElementRef.current?.getValue() || !actionCardsElementRef.current) return

    const keywords = getActiveTagNames(actionCardsElementRef.current.getValue() as ActionCardData)

    setIsCompletionKeywordsMatched(checkCompletionKeywords(keywords, completionKeywords) ?? false)
  }, [actionCardsElementRef, completionKeywords])

  useMountEffect(() => {
    adjustCompletionKeywordsState()
  })

  return { isCompletionKeywordsMatched, adjustCompletionKeywordsState }
}

export default useCompletionKeywordsMatch
